import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

import { PRIVACY_POLICY_URL } from '@global';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'fl-service-provider-request',
  styleUrls: ['./service-provider-request.component.scss'],
  templateUrl: './service-provider-request.component.html'
})
export class ServiceProviderRequestComponent implements OnInit {
  @Input() providerName: string;
  @Input() image: string;
  @Input() clientName: string;

  @Output() allow: EventEmitter<any> = new EventEmitter();
  @Output() deny: EventEmitter<any> = new EventEmitter();

  submitting: boolean;

  readonly PRIVACY_POLICY_URL = PRIVACY_POLICY_URL;

  constructor() {}

  ngOnInit() {
    this.submitting = false;
  }

  allowProvider(): void {
    this.submitting = true;
    this.allow.emit();
  }

  denyProvider(): void {
    this.submitting = true;
    this.deny.emit();
  }
}
